import { LOCALES } from 'i18n/locales';

export const mapToolbarIntl = {
    [LOCALES.ENGLISH]: {
        'continueEnquiryButton.text': 'Continue enquiry',
        'continueWorkpackButton.text': 'Continue PDF',
        'mapToolbar.dropdown.toggle': 'Toggle dropdown',
        'mapToolbar.dropdown.options': 'Dropdown options',
        'mapToolbar.drawButton.box': 'Draw area',
        'mapToolbar.drawButton.polygon': 'Draw custom area',
        'mapToolbar.drawButton.line': 'Draw line',
        'mapToolbar.clearButton.text': 'Clear',
        'mapToolbar.clearDialog.title': 'Clear your currently selected area',
        'mapToolbar.clearDialog.body': 'Are you sure you would like to clear your currently selected area?',
        'mapToolbar.clearDialog.note': 'Note: a new area is required to be drawn to view assets',
        'mapToolbar.editButton.text': 'Edit Area',
        'mapToolbar.recentreButton.text': 'Recentre map',
        'mapToolbar.recentreButton.notification': 'Map centred on your area',
        'mapToolbar.finishButton.text': 'Finish',
        'mapToolbar.addPoints': 'Click on the map to add points',
        'mapToolbar.startDrawing': 'Click on the map to start drawing...',
        'mapToolbar.mobile.create.aoi.dialog.title': 'Confirm area',
        'mapToolbar.mobile.create.aoi.dialog.message': 'Are you sure you want to retrieve assets in your selected area?',
        'mapToolbar.save.bookmark': 'Save bookmark',
        'mapToolbar.share': 'Share',
        'mapToolbar.create.pdf': 'Create PDF',
        'mapToolbar.new.enquiries': 'Make enquiry'
    },
    [LOCALES.WELSH]: {
        'continueEnquiryButton.text': 'Parhau ymholiad',
        'continueWorkpackButton.text': '[Continue PDF]',
        'mapToolbar.dropdown.toggle': '[Toggle dropdown]',
        'mapToolbar.dropdown.options': '[Dropdown options]',
        'mapToolbar.drawButton.box': 'Lluniadu ardal',
        'mapToolbar.drawButton.polygon': 'Lluniadu ardal arbennig',
        'mapToolbar.drawButton.line': '[Draw line]',
        'mapToolbar.clearButton.text': 'Clir',
        'mapToolbar.clearDialog.title': 'Cliriwch yr ardal yr ydych wedi\'i dewis ar hyn o bryd',
        'mapToolbar.clearDialog.body': 'Ydych chi\'n siŵr yr hoffech chi glirio\'r ardal yr ydych wedi\'i dewis ar hyn o bryd?',
        'mapToolbar.clearDialog.note': 'Sylwer: mae angen llunio ardal newydd i weld asedau',
        'mapToolbar.editButton.text': 'Golygu Ardal',
        'mapToolbar.recentreButton.text': 'Ailganoli\'r map',
        'mapToolbar.recentreButton.notification': 'Map wedi\'i ganoli ar eich ardal',
        'mapToolbar.finishButton.text': 'Gorffen',
        'mapToolbar.addPoints': '[Click on the map to add points.]',
        'mapToolbar.startDrawing': 'Cliciwch ar y map i ddechrau tynnu llun...',
        'mapToolbar.mobile.create.aoi.dialog.title': 'Cadarnhau ardal',
        'mapToolbar.mobile.create.aoi.dialog.message': 'Ydych chi\'n siŵr eich bod am adfer asedau yn eich dewis ardal?',
        'mapToolbar.save.bookmark': 'Cadw dalen-nodyn',
        'mapToolbar.share': 'Rhannu',
        'mapToolbar.create.pdf': '[Create PDF]',
        'mapToolbar.new.enquiries': '[Make enquiry]'
    }
};
